import { detectedByLabels } from '../data/detectedByLabels';
import { labelMap } from '../data/exporterLabels';

export function humanizeSource(value) {
  if (!value) return '-';
  if (value.includes(', ')) {
    return value.split(', ').map(humanizeOne).join(', ');
  }
  return humanizeOne(value);
}

function humanizeOne(value) {
  if (detectedByLabels[value]) return detectedByLabels[value];
  if (labelMap[value]) return labelMap[value];
  return value.replace(/_/g, ' ').replace(/[ -]\w|^\w/g, c => c.toUpperCase());
}
